function toggleDesktopMenu() {
  var menu = document.getElementById('desktop-mobile-menu');
  var wasOpen = menu.classList.contains('active');
  menu.classList.toggle('active');

  var headerWrapper = document.getElementById('header-wrapper');
  headerWrapper.classList.toggle('active'); 

  var backdrop = document.getElementById('custom-header-backdrop');
  backdrop.classList.toggle('active');

  var header = document.getElementsByClassName('section-header')[0];
  if (header) {
    header.classList.toggle('menu-open');  
    header.classList.toggle('sticky');
  }

  const filtersDrawer = document.querySelector('.filters-drawer-enabled');
  if (filtersDrawer && filtersDrawer.classList.contains('drawer-open')) {
    toggleFilters();
  }

  setDynamicColumns();

  var isOpen = menu.classList.contains('active');
  var hamburgerIcon = document.getElementById('hamburger-icon');

  if (hamburgerIcon) {
    hamburgerIcon.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  if (isOpen && !wasOpen) {
    // Keep keyboard users inside the opened desktop menu.
    const focusableItems = typeof getFocusableElements === 'function'
      ? getFocusableElements(menu)
      : Array.from(menu.querySelectorAll('a[href], button:enabled, [tabindex]:not([tabindex^="-"])'));
    if (focusableItems.length > 0) {
      if (typeof trapFocus === 'function') {
        trapFocus(menu, focusableItems[0]);
      } else {
        focusableItems[0].focus();
      }
    }
  } else if (!isOpen && wasOpen) {
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(hamburgerIcon);
    } else if (hamburgerIcon) {
      hamburgerIcon.focus();
    }
  }
} 

function toggleMobileMenu() {
  var menu = document.getElementById('Details-menu-drawer-container');
  menu.classList.toggle('menu-opening');
  menu.toggleAttribute('open');

  var header = document.getElementsByClassName('section-header')[0];
  if (header) {
    header.classList.toggle('menu-open');  
    header.classList.toggle('sticky');
    document.body.classList.toggle('hamburger-menu-open');
  }
}

function closeMobileMenu() {
  var menu = document.getElementById('Details-menu-drawer-container');
  if (!menu || !menu.hasAttribute('open')) return;

  menu.classList.remove('menu-opening');
  menu.removeAttribute('open');
  menu.querySelectorAll('details').forEach(function(details) {
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
  });

  var header = document.getElementsByClassName('section-header')[0];
  if (header) {
    header.classList.remove('menu-open');
    header.classList.remove('sticky');
  }
  document.body.classList.remove(
    'hamburger-menu-open',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop'
  );

  if (typeof removeTrapFocus === 'function') {
    removeTrapFocus();
  }
}

document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('hamburger-icon').addEventListener('click', function() {
      if(isMobileDevice()){
        toggleMobileMenu();
      }else{
        toggleDesktopMenu();
      }
      
    });

    // Function to close the menu when clicking outside
    document.addEventListener('click', function(event) {
      if(!isMobileDevice()){
        var menu = document.getElementById('desktop-mobile-menu');
        const header =  document.getElementsByClassName('section-header')[0];
        const hamburgerIcon = document.getElementById('hamburger-icon');

        const isClickHeader = header.contains(event.target);
        const isClickInsideMenu = menu.contains(event.target);
        const isClickInsideIcon = hamburgerIcon.contains(event.target);
        const isClickInsideHeader = header && header.contains(event.target);

        if (isClickHeader && !isClickInsideMenu && !isClickInsideIcon) {
          if(menu.classList.contains('active')){
            toggleDesktopMenu();  
            return;
          }
        }

         // Additional behavior — completely outside menu, icon, and header
        const isClickOutside = !isClickInsideMenu && !isClickInsideHeader && !isClickInsideIcon;
        if (isClickOutside && menu && menu.classList.contains('active')) {
          toggleDesktopMenu();
        }



      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (isMobileDevice()) return;
      var menu = document.getElementById('desktop-mobile-menu');
      if (menu && menu.classList.contains('active')) {
        event.preventDefault();
        toggleDesktopMenu();
      }
    });

    // Function to close the menu when clicking outside
    const closeMenuButton = document.getElementById('close-menu');
    if(closeMenuButton){
    closeMenuButton.addEventListener('click', function() { 
      if(isMobileDevice()){
        var menu = document.getElementById('Details-menu-drawer-container');
        menu.classList.remove('menu-opening');
        menu.removeAttribute('open');

        var header = document.getElementsByClassName('section-header')[0];
        if (header) {
          header.classList.toggle('menu-open');  
          header.classList.toggle('sticky');
        }
      }
    });
    }
});




function setDynamicColumns(){
   const menuColumns = document.querySelectorAll('.menu-column');

    menuColumns.forEach(column => {
      // Avoid rebuilding columns repeatedly on every menu toggle.
      if (column.dataset.dynamicColumnsBuilt === 'true' || column.querySelector('.sub-columns')) {
        return;
      }

      const rootLists = Array.from(column.querySelectorAll(':scope > ul'));
      const items = rootLists.flatMap((list) => Array.from(list.querySelectorAll('li')));
      
      if (items.length > 5) {
        // Create a container for the sub-columns
        const subColumnsDiv = document.createElement('div');
        subColumnsDiv.classList.add('sub-columns');
        
        // Split the items into groups of 4
        while (items.length > 0) {
          const group = items.splice(0, 5); // Get up to 4 items from the array
          
          // Create a new ul for each group of up to 4 items
          const newColumn = document.createElement('ul');
          group.forEach(item => newColumn.appendChild(item));
          
          // Add the new column to the sub-columns container
          subColumnsDiv.appendChild(newColumn);
        }
        
        // Replace all original root lists with the new grouped sub-columns.
        rootLists.forEach((list) => list.remove());
        column.appendChild(subColumnsDiv);
      }

      column.dataset.dynamicColumnsBuilt = 'true';
    });

}
